// Wrap child name, deity name, and interest words in <mark> tags for HTML rendering.
// Case-insensitive whole-word matching. Escapes user input before regex.

function escapeReg(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function escapeHtml(s) {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function highlightStoryTokens(text, { childName, deityName, interests = [], siblingName }) {
  if (!text) return '';
  let html = escapeHtml(text);

  const applyMark = (pattern, cls) => {
    html = html.replace(pattern, (m) => `<mark class="tl-mark ${cls}">${m}</mark>`);
  };

  const names = [childName, siblingName].filter(Boolean);
  names.forEach((n) => {
    applyMark(new RegExp(`\\b${escapeReg(n)}\\b`, 'g'), 'tl-mark-child');
  });

  if (deityName) {
    // match the last word of deity (e.g. "Lord Ganesha" → highlight "Ganesha")
    const parts = deityName.trim().split(/\s+/);
    const key = parts[parts.length - 1];
    applyMark(new RegExp(`\\b${escapeReg(deityName)}\\b`, 'g'), 'tl-mark-deity');
    if (key !== deityName) {
      applyMark(new RegExp(`\\b${escapeReg(key)}\\b`, 'g'), 'tl-mark-deity');
    }
  }

  interests.forEach((i) => {
    if (!i) return;
    applyMark(new RegExp(`\\b${escapeReg(i)}\\b`, 'gi'), 'tl-mark-interest');
  });

  return html.replace(/\n/g, '<br/>');
}

export function splitStoryAtWords(text, wordLimit = 200) {
  const words = text.split(/(\s+)/); // keep whitespace as tokens
  let count = 0;
  let cut = words.length;
  for (let i = 0; i < words.length; i++) {
    if (/\S/.test(words[i])) count += 1;
    if (count >= wordLimit) {
      // try to cut at end of sentence
      // find next punctuation within 30 tokens
      for (let j = i; j < Math.min(i + 30, words.length); j++) {
        if (/[.!?][\s\n]*$/.test(words[j])) { cut = j + 1; break; }
      }
      if (cut === words.length && i + 1 < words.length) cut = i + 1;
      break;
    }
  }
  const first = words.slice(0, cut).join('');
  const second = words.slice(cut).join('');
  return { first, second };
}
